import React, { Component, Suspense } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './Body.scss';
import * as Constants from '../../utilities/constants/Constants';
import * as pageControllerActions from '../../redux/pageControllerActions';
import * as modalActions from '../../redux/modalActions';
import * as helperFunctions from '../../utilities/HelperFunctions/HelperFunctions';
import * as gaHelpers from '../../utilities/GAHelpers/GAHelpers';
import * as homeActions from '../../redux/homeActions';
import * as fabricCanvasActions from '../../redux/fabricCanvasActions';

const ModelComponent = React.lazy(() =>
  import('./ModelComponent/ModelComponent')
);
const DesignComponent = React.lazy(() =>
  import('./DesignComponent/DesignComponent')
);
const FinalCheck = React.lazy(() => import('./FinalCheck/FinalCheck'));
const VanillaFinalCheck = React.lazy(() =>
  import('../../components/VanillaDesign/VanillaFinalCheck/VanillaFinalCheck')
);
const RipSelection = React.lazy(() =>
  import('../../components/RipSelection/RipSelection')
);
const Processing = React.lazy(() =>
  import('../../components/Processing/Processing')
);
const PostersDone = React.lazy(() =>
  import('../../components/PostersDone/PostersDone')
);

class Body extends Component {
  componentDidMount() {
    const { dispatchers, selectedProduct } = this.props;
    dispatchers.gaHelpers.sendDesignerLaunchGAEvents();
    dispatchers.pageControllerActions.setUpPages();
    const isSignageSuite = helperFunctions.isSignageSuiteProduct();
    if (isSignageSuite && selectedProduct === null) {
      dispatchers.modalActions.checkForSingleProduct();
    }
  }

  componentDidUpdate(prevProps) {
    const { selectedProduct, page, sendGA, dispatchers, language } = this.props;
    const isSignageSuite = helperFunctions.isSignageSuiteProduct();
    if (prevProps.page !== page) {
      if ((isSignageSuite && selectedProduct) || !isSignageSuite) {
        if (sendGA) {
          dispatchers.gaHelpers.gaOfPageChange(page);
        }
      }
    }
    if (prevProps.language !== language) {
      dispatchers.pageControllerActions.setUpPages();
    }
  }

  shouldDisplayHomePage = applySizeThroughUrl => {
    const {
      selectedProduct,
      page,
      projectWidth,
      projectHeight,
      isVanilla
    } = this.props;

    let signageSizeSelectionPage = false;
    if (
      selectedProduct &&
      selectedProduct.constraintType == Constants.CONSTRAINT_TYPE_CUSTOM &&
      !projectWidth &&
      !projectHeight
    ) {
      signageSizeSelectionPage = true;
    }

    let wallartSizeSelectionPage = false;
    if (
      !projectWidth &&
      !projectHeight &&
      !isVanilla &&
      !applySizeThroughUrl &&
      helperFunctions.isModelPage(page)
    ) {
      wallartSizeSelectionPage = true;
    }
    if (signageSizeSelectionPage || wallartSizeSelectionPage) {
      return true;
    }
    return (
      !selectedProduct &&
      helperFunctions.isModelPage(page) &&
      !applySizeThroughUrl
    );
  };

  shouldDisplayDesignPage = () => {
    const { page, progressData } = this.props;
    return page === Constants.DESIGN_PAGE && progressData <= 100;
  };

  shouldDisplayReviewOrderPage = () => {
    const { page, isVanilla } = this.props;
    return page === Constants.FINAL_CHECK_PAGE && !isVanilla;
  };

  shouldDisplayVanillaPrintPage = () => {
    const { page, isVanilla } = this.props;
    return (
      (page === Constants.FINAL_CHECK_PAGE || page === Constants.PRINT_PAGE) &&
      isVanilla
    );
  };

  shouldDisplayInitialPrintPage = () => {
    const { page, isVanilla } = this.props;
    return page === Constants.INITIAL_PRINT_PAGE && isVanilla;
  };

  shouldDisplayFileProcessingPage = () => {
    const { page, isVanilla } = this.props;
    return page === Constants.FILE_PROCESSING_PAGE && isVanilla;
  };

  shouldDisplayDesignSharePage = () => {
    const { page, isVanilla } = this.props;
    return page === Constants.DESIGN_SHARE_PAGE && isVanilla;
  };

  render() {
    const {
      progressData,
      envData,
      dispatchers,
      isVanilla,
      page,
      storeId
    } = this.props;

    let applySizeThroughUrl = false;
    const colorString = `${Constants.NORMAL_WALL_COLOR}`;

    if (isVanilla && page === 0 && progressData === 100) {
      dispatchers.homeActions.setDefaultWallVanilla();
      dispatchers.pageControllerActions.setCurrentPageIndex(
        Constants.DESIGN_PAGE
      );
    }

    if (dispatchers.modalActions.isApplicationSizeFromURL() && page < 3) {
      applySizeThroughUrl = true;
      dispatchers.homeActions.setSizeFromApplicationUrl(
        envData.product_width,
        envData.product_height
      );
    }

    let bodyContents = null;
    if (this.shouldDisplayHomePage(applySizeThroughUrl)) {
      bodyContents = (
        <div style={{ backgroundColor: colorString }}>
          <ModelComponent />
        </div>
      );
    }

    if (this.shouldDisplayDesignPage()) {
      bodyContents = <DesignComponent />;
    }

    if (this.shouldDisplayReviewOrderPage()) {
      bodyContents = <FinalCheck />;
    }

    if (this.shouldDisplayVanillaPrintPage()) {
      bodyContents = <VanillaFinalCheck />;
    }

    if (this.shouldDisplayInitialPrintPage()) {
      bodyContents = <RipSelection storeId={storeId} />;
    }

    if (this.shouldDisplayFileProcessingPage()) {
      bodyContents = <Processing />;
    }

    if (this.shouldDisplayDesignSharePage()) {
      bodyContents = (
        <PostersDone createNew={dispatchers.homeActions.createNewProject} />
      );
    }
    return (
      <Suspense
        fallback={
          <div className=' loading-indicator-suspense-fallback' id='loader' />
        }
      >
        {bodyContents}
      </Suspense>
    );
  }
}

function mapStateToProps(state) {
  return {
    progressData: state.modal.progressData,
    projectWidth: state.home.projectWidth,
    projectHeight: state.home.projectHeight,
    productSizes: state.modal.productSizes,
    language: state.home.language,
    page: state.pageController.currentPageIndex,
    isVanilla: state.modal.envData.is_vanilla_designer,
    wallSize: state.modal.productSizes.default.sizes,
    storeId: state.modal.storeData.id,
    category: state.modal.envData.category,
    customWidth: state.home.customWall.customWidth,
    customHeight: state.home.customWall.customHeight,
    envData: state.modal.envData,
    projectGroupId: state.finalCheck.project.projectGroupId,
    selectedProduct: state.home.selectedProduct,
    storeData: state.modal.storeData,
    sendGA: state.fabricCanvas.sendReviewGA
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      homeActions: bindActionCreators(homeActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      pageControllerActions: bindActionCreators(
        pageControllerActions,
        dispatch
      ),
      modalActions: bindActionCreators(modalActions, dispatch),
      helperFunctions: bindActionCreators(helperFunctions, dispatch),
      gaHelpers: bindActionCreators(gaHelpers, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Body);
